module.exports = __webpack_public_path__ + "img/walknitsuite.adf5ad1a.png";